import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  component: App,
  beforeLoad: () => {
    throw redirect({ to: '/library' })
  },
})

function App() {
  return (
    // eslint-disable-next-line i18next/no-literal-string -- non-rendered placeholder (route redirects in beforeLoad); brand string
    <div className="p-4 text-center">Linq frontend gen3</div>
  )
}
